import Logo from 'components/Shared/Logo';
import { useSelector } from 'react-redux';
import { rm } from 'utils';
import { IconArrow } from 'components/Shared/Icon';
import { isMobile, isMobileLayout } from 'components/Shared/responsive';
import styles from './styles.scss';

interface BackButtonProps {
  mobileAndTablet: boolean;
}

const BackButton = ({ mobileAndTablet }: BackButtonProps) => (
  <a href="/" className={styles.continue}>
    <div className={styles.arrow}>
      <IconArrow appearance="flip-180" />
    </div>
    {!mobileAndTablet && <span className={styles.back}>{rm('cart_hover_button_back')}</span>}
  </a>
);

export const Header = () => {
  const mobileLayout = useSelector(isMobile);
  const mobileAndTablet = useSelector(isMobileLayout);

  return (
    <div className={styles.header}>
      <div className={styles.left}>
        {mobileLayout ? (
          <Logo wrapperClassName={styles.logoDesktop} />
        ) : (
          <BackButton mobileAndTablet={mobileAndTablet} />
        )}
      </div>

      <div className={styles.center}>
        {mobileLayout ? (
          <BackButton mobileAndTablet={mobileAndTablet} />
        ) : (
          <Logo wrapperClassName={styles.logoDesktop} />
        )}
      </div>

      {!mobileLayout && <div className={styles.right} />}
    </div>
  );
};
